import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { confirmAlert, errorAlert } from "../../Components/Alerts/BasicAlert";
import useAdmin from "./useAdmin";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import swal from 'sweetalert';
import { formatDateForDB } from "../../bootstrap/ReusableFunctionsBootstrap";

export default function () {
  const { reset, handleSubmit, setErrors, editAdminFields, setData } = useAdmin();
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`admins/${id}/edit`).then(res => {
      if(res.data.status === 'success'){
        reset(res.data.data.admin);
        setData(res.data.data)
      }
    });
  }, []);

  const deleteAdmin = () => {
    confirmAlert('You want to remove this user permanently?', handleDelete, ["No", "Yes"])
  };

  const handleDelete = () => {
    axios.delete('admins/' + id).then(function (res) {
        if (res.status == 200) {
          swal(`Admins has been deleted successfully!`, {
            icon: "success",
          });

          navigate("/admins")
        }
      })
      .catch(function (error) {
        if (error.response) {
          console.log(error.response.data.errors);
        }
      });
  }

  const editAdmin = data => {
    data.birthday = typeof data.birthday == "undefined" ? null : formatDateForDB(data.birthday);
    const formData = new FormData();

    Object.entries(data).forEach(([property, value]) => {
      formData.append(`${property}`, value || '');
    });

    formData.append("_method", "PATCH");

    axios.post('admins/' + data.id, formData)
      .then(function (res) {
        if (res.status == 200) {
          swal('Admin has been updated successfully!', {
            icon: "success",
          });
          navigate("/admins");
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.errors || {});
        }
      });
  }

  return (
    <Card title="Edit admin">
      <form className="form w-100 row" onSubmit={handleSubmit(editAdmin)}>
        {editAdminFields}
        <div className="col-12">
          <SubmitButton title="Update" classes="d-inline-block w-auto" />
          <button
            className="btn btn-lg btn-danger mb-5 d-inline-block w-auto float-right"
            type="button"
            onClick={()=>{deleteAdmin()}}
          >
            Delete
          </button>
        </div>
      </form>
    </Card>
  );
}